import { render, staticRenderFns } from "./nav-drawer.vue?vue&type=template&id=4c538382"
import script from "./nav-drawer.vue?vue&type=script&lang=js"
export * from "./nav-drawer.vue?vue&type=script&lang=js"
import style0 from "./nav-drawer.vue?vue&type=style&index=0&id=4c538382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports